/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { NavLink, useLocation } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageListItem from '@mui/material/ImageListItem';
import RestoreIcon from '@mui/icons-material/Restore';
import BackupIcon from '@mui/icons-material/Backup';
import PersonIcon from '@mui/icons-material/Person';
import { Hidden, Box } from '@mui/material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import inetlogo from '../../assets/images/inetlogo.png';
import MobileSidebar from './MobileSidebar';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import BusinessIcon from '@mui/icons-material/Business';
import jwtDecode from 'jwt-decode';
import { getStorage } from '../../utils/functions/localstorage';
import { ROLES } from '../../utils/constants';
const drawerWidth = 260;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

const decodeJwt = (data) => {
  const decoded = jwtDecode(data);
  return decoded;
};

const getRole = () => {
  const token = getStorage('token') || '';
  const decodeToken = token ? decodeJwt(token) : '';
  const { ROLE } = decodeToken;
 
  return ROLE;
};


const items = [
  {
    href: '/Dashboard-display',
    icon: DataUsageIcon,
    title: 'แดชบอร์ด',
    sub: [],
  },
  {
    href: '/upload-admin',
    icon: BackupIcon,
    title: 'อัปโหลดข้อมูล',
    sub: [],
  },
  {
    href: '/invoice-list',
    icon: AssignmentOutlinedIcon,
    title: 'รายการใบแจ้งหนี้',
    sub: [],
  },
  {
    href: '/payment-list-admin',
    icon: RestoreIcon,
    title: 'ประวัติการชำระเงิน',
    sub: [],
  },
  {
    href: '/email-management',
    icon: AttachEmailIcon,
    title: 'การจัดการอีเมล',
    sub: [],
  },
  {
    href: '/config-list',
    icon: ManageAccountsIcon,
    title: 'จัดการลูกหนี้',
    sub: [],
  },
];

if (getRole() === ROLES.SUPER_ADMIN_ROLE) {
  items.push( {
    href: '/company-list',
    icon: AddBusinessIcon,
    title: 'รายการร้านค้า',
    sub: [],
  }
)
}

export default function MiniDrawer({ onMobileClose, openMobile, children }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Hidden lgDown>
        <Drawer variant="permanent" open={open}>
          <ListItem component="div" disablePadding sx={{ display: 'flex' }}>
            <ListItemButton
              onClick={() => {
                if (open) {
                  handleDrawerClose();
                } else {
                  handleDrawerOpen();
                }
              }}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
              }}
            >
              <ImageListItem sx={{ maxWidth: open ? '50px' : '60px' }}>
                <img src={`${inetlogo}`} />
              </ImageListItem>
              <ListItemText
                sx={{ opacity: open ? 1 : 0, ml: open ? '10px' : 0 }}
              >
                <div className="text-sm">Internet Thailand</div>
                <div className="text-sm">Public Company Limited</div>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <List sx={{}}>
            {items.map((item) => (
              <NavLink key={item.title} to={item.href}>
                <ListItem
                  sx={{
                    display: 'block',
                    ...(item.href === location.pathname && {
                      backgroundColor: 'lightGreen.main',
                      borderRadius: 3,
                      color: 'lightGreen.text',
                    }),
                  }}
                >
                  <ListItemButton
                    sx={{
                      height: 40,
                      justifyContent: open ? 'initial' : 'center',
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                      <item.icon
                        sx={{
                          ...(item.href === location.pathname && {
                            color: 'lightGreen.text',
                          }),
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.title}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            ))}
          </List>
        </Drawer>
      </Hidden>

      <Hidden lgUp>
        <MobileSidebar
          onMobileClose={onMobileClose}
          openMobile={openMobile}
          items={items}
        />
      </Hidden>

      {/* <Box component="main" sx={{ flexGrow: 1, p: 3, overflowX: 'auto' }}>
        <DrawerHeader />
        <div className="container">{children}</div>
      </Box> */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}
